export const elements = {
  bodyElement: document.querySelector("body"),
  navToggler: document.getElementById("navigation-toggler"),
  animatedElements: document.querySelectorAll(".animated-in-view")
};
